import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/financeiro')({
  component: lazyRouteComponent(
    () => import('@/features/financeiro/components/financeiro-dashboard'),
    'FinanceiroDashboard'
  ),
})
